import React from 'react';
import { Link2, X } from 'lucide-react';

const COLOR_MAP = {
  emerald: { bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-700', text2: 'text-emerald-800', focus: 'focus:ring-emerald-400/40', borderHov: 'hover:border-emerald-300', bgHov: 'hover:bg-emerald-50/30', activeBg: 'bg-emerald-50', activeBorder: 'border-emerald-300', icon: 'text-emerald-600' },
  amber:   { bg: 'bg-amber-50',   border: 'border-amber-200',   text: 'text-amber-700',   text2: 'text-amber-800',   focus: 'focus:ring-amber-400/40',   borderHov: 'hover:border-amber-300',   bgHov: 'hover:bg-amber-50/30',   activeBg: 'bg-amber-50',   activeBorder: 'border-amber-300',   icon: 'text-amber-600' },
  sky:     { bg: 'bg-sky-50',     border: 'border-sky-200',     text: 'text-sky-700',     text2: 'text-sky-800',     focus: 'focus:ring-sky-400/40',     borderHov: 'hover:border-sky-300',     bgHov: 'hover:bg-sky-50/30',     activeBg: 'bg-sky-50',     activeBorder: 'border-sky-300',     icon: 'text-sky-600' },
};

/**
 * Modale per collegare un preventivo a Pratica / Cantiere / Computo Metrico.
 */
export default function PreventivoLinkModal({
  linkModal,          // { tipo, preventivo, search }
  cfg,                // LINK_CONFIG[tipo]
  onClose,
  onSearchChange,     // (newSearch) => void
  onLink,             // (targetId) => Promise
  onUnlink,           // () => Promise
  getInfo,            // (tipo, id) => item
  getName,            // (item, tipo) => string
}) {
  const c = COLOR_MAP[cfg.color] || COLOR_MAP.emerald;
  const currentId = linkModal.preventivo[cfg.field];
  const currentItem = getInfo(linkModal.tipo, currentId);
  const items = (cfg.items() || []).filter(it => !it.archived);
  const s = (linkModal.search || '').toLowerCase().trim();
  const filtered = items.filter(it => {
    if (!s) return true;
    const name = (getName(it, linkModal.tipo) || '').toLowerCase();
    const code = (it.numero_pratica || it.codice_cantiere || it.codice_computo || '').toLowerCase();
    const cli = (it.cliente_nome || '').toLowerCase();
    return name.includes(s) || code.includes(s) || cli.includes(s);
  });

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-md w-full max-w-2xl max-h-[85vh] flex flex-col shadow-2xl animate-fade-in">
        <div className="flex items-center justify-between p-5 border-b border-slate-200">
          <div>
            <h3 className={`text-lg font-bold flex items-center gap-2 ${c.text}`}>
              <Link2 size={18} className={c.icon} /> Collega a {cfg.label}
            </h3>
            <p className="text-xs text-slate-500 mt-0.5">
              Preventivo: {linkModal.preventivo.titolo || linkModal.preventivo.numero_preventivo}
            </p>
          </div>
          <button onClick={onClose} aria-label="Chiudi">
            <X size={20} className="text-slate-400 hover:text-slate-800" />
          </button>
        </div>
        <div className="p-5 flex-1 overflow-y-auto">
          {currentId && (
            <div className={`mb-3 p-3 ${c.bg} border ${c.border} rounded-md flex items-center justify-between gap-2 flex-wrap`}>
              <div className="text-sm">
                <p className={`font-bold ${c.text}`}>Attualmente collegato a:</p>
                <p className={c.text2}>{getName(currentItem, linkModal.tipo) || 'Non trovato/a'}</p>
              </div>
              <button onClick={onUnlink} className="text-xs font-bold px-3 py-1.5 bg-red-100 hover:bg-red-200 text-red-700 rounded" data-testid="unlink-btn">
                Scollega
              </button>
            </div>
          )}
          <input
            placeholder={cfg.placeholder}
            value={linkModal.search || ''}
            onChange={e => onSearchChange(e.target.value)}
            className={`w-full px-3 py-2.5 border border-slate-300 rounded-md text-sm mb-3 focus:ring-2 ${c.focus}`}
            autoFocus
            data-testid="link-search"
          />
          <div className="space-y-1.5 max-h-96 overflow-y-auto">
            {filtered.slice(0, 50).map(it => {
              const isActive = currentId === it.id;
              const sub = [it.numero_pratica || it.codice_cantiere || it.codice_computo, it.cliente_nome, it.stato].filter(Boolean).join(' · ');
              return (
                <button
                  key={it.id}
                  type="button"
                  onClick={() => onLink(it.id)}
                  className={`w-full text-left p-3 rounded border transition-all flex items-center gap-3 ${isActive ? `${c.activeBg} ${c.activeBorder}` : `bg-white border-slate-200 ${c.borderHov} ${c.bgHov}`}`}
                  data-testid={`option-${it.id}`}
                >
                  <div className="flex-1 min-w-0">
                    <p className="font-bold text-sm truncate">{getName(it, linkModal.tipo) || '(senza titolo)'}</p>
                    {sub && <p className="text-xs text-slate-500 truncate">{sub}</p>}
                  </div>
                  {isActive && <span className={`${c.icon} text-xs font-bold`}>attivo</span>}
                </button>
              );
            })}
            {filtered.length === 0 && (
              <p className="text-sm text-slate-400 italic text-center py-6">
                Nessun risultato. {items.length === 0 && `Crea prima un/una ${cfg.label.toLowerCase()}.`}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
